import React, { useEffect, useState } from "react";
import SignUpFlow from "./Auth/Layout";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthSubmit } from "./../api";

import { useAuth } from "./../hooks";
import { getSession } from "./../axios.config";
import { Button } from "./../Components/ui/button";
import { useQueryClient } from "@tanstack/react-query";
import Loader from "./../Components/Loader/PageLoader";
import BackToUnified from "./../Components/sideBar/backToUnified.js";

function SelfieEmptyRoute() {
  const [isSubmitting, setIsSubmitting] = useState(
    " Redirecting to home page ...",
  );
  const queryClient = useQueryClient();
  const { setStateVariable, setFormData } = useAuth();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const Status = searchParams.get("status") || "";

  useEffect(() => {
    async function authComplete() {
      try {
        if (Status !== "REJECTED" || Status !== "Failed") {
          await AuthSubmit();
          navigate("/homeVerification", { replace: true });
        } else {
          setIsSubmitting("Video validation failed, Please try again!");
        }
      } catch (error) {
        setIsSubmitting("Something failed Please try again after sometime");
      }
    }
    authComplete();
  }, []);

  const user = JSON.parse(getSession("userId"));

  useEffect(() => {
    setFormData({
      ...user,
      pan: user?.panNumber,
      mobileNumber: user?.mobile?.replace(/^\+91\s*/, ""),
      dob: user?.dateOfBirth ? new Date(user?.dateOfBirth) : null,
    });
  }, []);

  const userDetails = user?.currentStep || user?.userData?.currentStep;

  useEffect(() => {
    if (userDetails === "REGISTER") {
      navigate("/details", { replace: true });
      setStateVariable(1);
    }
    if (userDetails === "PERSONAL_INFO") {
      navigate("/details", { replace: true });
      setStateVariable(2);
    }
    if (userDetails === "SIGNUP") {
      setStateVariable(3);
      // navigate("/details", { replace: true });
    }
    if (userDetails === "DOC_UPLOAD") {
      setStateVariable(4);
      queryClient.invalidateQueries({
        queryKey: ["beneficiarySelfieDetails"],
      });
      // navigate("/details", { replace: true });
    }
    if (userDetails === "SELFIEE_UPLOAD") {
      // setStateVariable(5);
      navigate("/redirect?status=success", {
        replace: true,
      });
    }
  }, []);

  return (
    <>
      <SignUpFlow>
        <div className="flex flex-col items-center justify-center w-full h-full gap-5">
          <Loader />
          {isSubmitting}
          {(Status === "REJECTED" || Status === "Failed") && (
            <Button
              onClick={() => navigate("/details", { replace: true })}
              className="w-20"
            >
              Retry
            </Button>
          )}
        </div>
      </SignUpFlow>
      <BackToUnified />
    </>
  );
}

export default SelfieEmptyRoute;
